export const THEME_COLOR_META_ID = 'theme-color'

export const THEME_COLOR_META = {
  light: '#ffffff',
  dark: '#39393C',
}

export const MYPLACE_DARK_MODE_CLASSNAMES = ['place_apply_darkmode', 'pui__apply_darkmode']

const getNaverAppVersion = () => {
  const userAgent = window.navigator.userAgent
  if (typeof userAgent !== 'string') return 0
  const regExp = new RegExp('NAVER\\(inapp;.* (\\d+);.* (\\d+)\\.*(\\d+)*\\.*(\\d+)*', 'i')
  const group = regExp.exec(userAgent)
  if (group && group.length > 1) {
    return Number(group[1])
  }
  return 0
}

const getIsDarkModeAvailableNaverAppVersion = () => {
  const userAgent = window.navigator.userAgent
  const isNaverApp = /NAVER/.test(userAgent)
  const naverAppVersion = getNaverAppVersion()

  return isNaverApp && naverAppVersion >= 1000
}

const getNaverColorSchemeCookie = () => {
  const NAVER_SYSTEM_COLOR_SCHEME_KEY = 'NSCS'

  const value = window.document.cookie.match(`(^|;) ?${NAVER_SYSTEM_COLOR_SCHEME_KEY}=([^;]*)(;|$)`)
  return value ? value[2] : null
}

export const getDarkModeQuery = () => window?.matchMedia('(prefers-color-scheme: dark)')

export const checkSupportDarkMode = () => {
  const userAgent = window.navigator.userAgent

  const isFromMapsApp = userAgent && userAgent.indexOf('NAVER(inapp; map;') > -1

  if (isFromMapsApp) {
    return false
  }

  return getNaverColorSchemeCookie() === '1' || getIsDarkModeAvailableNaverAppVersion()
}

export const createThemeColorMetaTag = (isDarkMode: boolean) => {
  const meta = document.createElement('meta')
  const THEME_COLOR_META_ID = 'theme-color'
  const THEME_COLOR_META = {
    light: '#ffffff',
    dark: '#39393C',
  }

  meta.id = THEME_COLOR_META_ID
  meta.name = THEME_COLOR_META_ID
  meta.content = isDarkMode ? THEME_COLOR_META.dark : THEME_COLOR_META.light
  window.document.getElementsByTagName('head')[0].appendChild(meta)
}

const DarkModeTag = () => {
  const attachDarkModeClassBeforeRendering = String(() => {
    const MYPLACE_DARK_MODE_CLASSNAMES = ['place_apply_darkmode', 'pui__apply_darkmode']
    const isDarkMode = checkSupportDarkMode() && getDarkModeQuery().matches

    if (isDarkMode) {
      document.body.setAttribute('class', MYPLACE_DARK_MODE_CLASSNAMES.join(' '))
    }

    createThemeColorMetaTag(isDarkMode)
  })

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `{
        ${[
          getNaverAppVersion,
          getIsDarkModeAvailableNaverAppVersion,
          getNaverColorSchemeCookie,
          getDarkModeQuery,
          checkSupportDarkMode,
          createThemeColorMetaTag,
        ]
          .map(func => `const ${func.name} = ${String(func)}\n`)
          .join('\n')}
        \n
        (${attachDarkModeClassBeforeRendering})()
      }`,
      }}
    />
  )
}

export default DarkModeTag
